import React from "react"
import moment from "moment"
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom"
import "./Transactions.css"
import Card, { StickyCard } from "../core/Card"
import {
  Icon,
  BackIcon,
  BriefcaseIcon,
  CoinIcon,
  RefundIcon
} from "../core/icons"
import {
  Button,
  Select,
  DatePicker,
  Icon as AIcon,
  Tag,
  Tooltip,
  Popover,
  Checkbox,
  Dropdown,
  Row,
  Col,
  message,
  Menu,
  Popconfirm
} from "antd"
import { connect } from "react-redux"
import Summary from "./Summary"
import { withPreviousDate, getFilterCount } from "./reducer"
import TransactionLine from "./TransactionLine"
import EmptyState from "../core/components/EmptyState"
import Filter from "./Filter"
import BulkActions from "./BulkActions"
import { loadMore, getTransactions, clearFilters } from "./actions"
import { StickyContainer, Sticky } from "react-sticky"
import SlidingLines from "../core/SlidingLines"

const mapStateToProps = ({ transactions, models }) => ({
  ...transactions,
  transactions: withPreviousDate(models.transactions),
  filterCount: getFilterCount(transactions.filterValues),
  hasSelected: transactions.filter_params.token_ids.length > 0
})

const All = connect(
  mapStateToProps,
  { loadMore, getTransactions, clearFilters }
)(
  ({
    filterCount,
    transactions,
    loadMore,
    isFetching,
    getTransactions,
    endOfList,
    tags,
    hasSelected,
    totalResultsCount,
    clearFilters
    // checked/selected items:
    // selectedCount=filter_params.token_ids.length
  }) => (
    <Card className="Table" gridArea="Table">
      <Row
        className={hasSelected ? "actions selected" : "actions"}
        type="flex"
        justify="space-between"
        align="middle"
      >
        <Col xs={13} md={13}>
          <Sticky
            topOffset={260}
            // disableCompensation={true}
          >
            {({
              style,
              // the following are also available but unused in this example
              isSticky,
              wasSticky,
              distanceFromTop,
              distanceFromBottom,
              calculatedHeight
            }) => {
              return (
                <div style={{ ...style, zIndex: 1020, top: "20px" }}>
                  {transactions &&
                    transactions.length > 0 && (
                      <BulkActions isSticky={isSticky} />
                    )}
                </div>
              )
            }}
          </Sticky>
        </Col>
      </Row>

      {/* TXNS */}
      {transactions && (
        <SlidingLines data={transactions} height={150}>
          {styles => (
            <div>
              {styles.map(c => {
                return (
                  <TransactionLine
                    transaction={c.data}
                    style={{
                      ...c.style,
                      overflow: "hidden"
                    }}
                    key={c.key}
                  />
                )
              })}
            </div>
          )}
        </SlidingLines>
      )}

      {/* FOOTER */}
      {transactions &&
        transactions.length > 0 && (
          <span className="footer">
            {totalResultsCount > 0 ? (
              <span className="results-count">
                {transactions.length} out of {totalResultsCount} results
              </span>
            ) : (
              <span />
            )}

            {filterCount > 0 && (
              <a
                style={{ color: "#2496C5", float: "right", fontSize: "larger" }}
                onClick={clearFilters}
              >
                {" "}
                Clear filters
              </a>
            )}

            {endOfList ? (
              <Button disabled={true}>No more transactions to load</Button>
            ) : (
              <Button loading={isFetching} onClick={loadMore}>
                Load more
              </Button>
            )}
          </span>
        )}

      {/* EMPTY STATE */}
      {transactions.length < 1 &&
        filterCount < 1 && (
          <EmptyState title="No Transactions yet." icon={CoinIcon} />
        )}

      {/* EMPTY STATE FILTER */}
      {transactions.length < 1 &&
        filterCount > 0 && (
          <EmptyState title="0 Transactions Found" icon={CoinIcon} />
        )}
    </Card>
  )
)

export default All



// WEBPACK FOOTER //
// ./src/transactions/All.js